// extracted by mini-css-extract-plugin
export default {"cls1":"XxMbjjW7iJJNa1Q2YwgT","cls2":"WZsKVpCJPCJlpVHvd4hE XxMbjjW7iJJNa1Q2YwgT"};